import { render } from "./TenantModel.vue?vue&type=template&id=42d4a9a9&scoped=true"
import script from "./TenantModel.js?vue&type=script&lang=js"
export * from "./TenantModel.js?vue&type=script&lang=js"

import "./TenantModel.vue?vue&type=style&index=0&id=42d4a9a9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d4a9a9"]])

export default __exports__